/* ============================================================
   KODAWARI — CART PAGE ENHANCEMENTS
   ------------------------------------------------------------
   Adds two things the cart page template is missing:
     0.7  quantity steppers (the drawer has them, the page doesn't)
     0.8  a Continue Shopping link

   Done in JS rather than Liquid because sections/main-cart-items.liquid
   is 64KB — past the size the API can safely read and rewrite. This
   avoids touching it at all. If that file is ever refactored, move
   this into the template and delete this file.
   ============================================================ */

(function () {
  'use strict';

  function isCartPage() {
    return document.body.classList.contains('template-cart') ||
           window.location.pathname.replace(/\/$/, '').endsWith('/cart');
  }

  function money(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  }

  /* ---------- quantity steppers ---------- */

  function buildStepper(line, qty) {
    var wrap = document.createElement('div');
    wrap.className = 'kw-qty';
    wrap.setAttribute('data-line', line);

    var minus = document.createElement('button');
    minus.type = 'button';
    minus.className = 'kw-qty__btn';
    minus.setAttribute('aria-label', 'Decrease quantity');
    minus.textContent = '−';

    var input = document.createElement('input');
    input.type = 'number';
    input.className = 'kw-qty__input';
    input.value = qty;
    input.min = '0';
    input.setAttribute('aria-label', 'Quantity');

    var plus = document.createElement('button');
    plus.type = 'button';
    plus.className = 'kw-qty__btn';
    plus.setAttribute('aria-label', 'Increase quantity');
    plus.textContent = '+';

    minus.addEventListener('click', function () { change(line, Math.max(0, parseInt(input.value, 10) - 1)); });
    plus.addEventListener('click', function () { change(line, parseInt(input.value, 10) + 1); });
    input.addEventListener('change', function () {
      var v = parseInt(input.value, 10);
      change(line, isNaN(v) || v < 0 ? 1 : v);
    });

    wrap.appendChild(minus);
    wrap.appendChild(input);
    wrap.appendChild(plus);
    return wrap;
  }

  function change(line, quantity) {
    document.body.classList.add('kw-cart-busy');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.reload(); })
      .catch(function () {
        document.body.classList.remove('kw-cart-busy');
        window.location.reload();
      });
  }

  function addSteppers() {
    var rows = document.querySelectorAll('tr.cart-item.page__cart-item');
    if (!rows.length) return;

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        rows.forEach(function (row, i) {
          if (row.querySelector('.kw-qty')) return;
          var item = cart.items[i];
          if (!item) return;

          var host = row.querySelector('.cart__page-price') ||
                     row.querySelector('.cart-item__details');
          if (!host) return;

          host.appendChild(buildStepper(i + 1, item.quantity));
        });
      })
      .catch(function () { /* leave the page as-is on failure */ });
  }

  /* ---------- continue shopping ---------- */

  function addContinueShopping() {
    var ctas = document.querySelector('.cart__ctas');
    if (!ctas || ctas.querySelector('.kw-continue')) return;

    var a = document.createElement('a');
    a.href = '/collections/sarees';
    a.className = 'kw-continue';
    a.textContent = '← Continue shopping';
    ctas.appendChild(a);
  }

  function init() {
    if (!isCartPage()) return;
    addSteppers();
    addContinueShopping();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
